import { type ObjectSchema, string, object } from 'yup';

import { Person, ProgramQualification } from '@/types/person';

export const programQualificationSectionSchema: ObjectSchema<
  Pick<Person, 'payment_type'> & {
    program_qualification?: Pick<ProgramQualification, 'primary_substance' | '_program_id'>;
  }
> = object({
  payment_type: string().optional().nullable().label('Payment type'),
  program_qualification: object()
    .shape({
      primary_substance: string().required().label('Primary Concern'),
      _program_id: string()
        .optional()
        .nullable()
        .label('Program')
        .transform((value) => {
          return value || null;
        }),
      treatment_preference: string().label('Treatment Preference').nullable()
    })
    .optional()
    .label('Program qualification')
});
